// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__t4Qf2","disabled":"FileBtn_disabled__3USN-","warn":"FileBtn_warn__38qfq","fade":"FileBtn_fade__1w-X8"};